import { CompanyContactPersonChargeDto, CurrencyIDs } from "Api/Api";
import {
  Column,
  PrimaryDataTable,
  TableIDType,
} from "Components/Shared/PrimaryDataTable/PrimaryDataTable";
import * as React from "react";
import styled from "styled-components";
import { formatMonthWithYear } from "Utils/DateUtils";
import { formatNumber } from "Utils/NumberUtils";

const StyledWrapper = styled.div`
  width: 535px;
  height: 400px;
  overflow: auto;
  padding: 0 ${props => props.theme.spacing(1)}px;
  margin-bottom: ${props => props.theme.spacing(2)}px;
`;

const StyledNoWrap = styled.div`
  white-space: nowrap;
`;

type Props = { charges: CompanyContactPersonChargeDto[] };

export const CompanyContactHistory: React.FunctionComponent<Props> = props => {
  const { charges } = props;

  const columns: Column<CompanyContactPersonChargeDto>[] = [
    {
      id: "dateFrom",
      label: "Platná od",
    },
    {
      id: "dateTo",
      label: "Platná do",
    },
    {
      id: "manDayCharge",
      label: "Sazba/MD",
    },
    {
      id: "createdBy",
      label: "Vytvořil",
    },
  ];

  const getCell: (
    id: TableIDType<CompanyContactPersonChargeDto>,
    data: CompanyContactPersonChargeDto,
  ) => JSX.Element = (id, data) => {
    switch (id) {
      case "dateFrom":
        return (
          <StyledNoWrap>{formatMonthWithYear(data.dateFrom)}</StyledNoWrap>
        );

      case "dateTo":
        return <StyledNoWrap>{formatMonthWithYear(data.dateTo)}</StyledNoWrap>;

      case "manDayCharge": {
        const unit = data.currencyID === CurrencyIDs.EUR ? "€" : "Kč";
        return (
          <StyledNoWrap>
            {formatNumber(data.manDayCharge, "-")} {unit}
          </StyledNoWrap>
        );
      }

      case "createdBy":
        return (
          <StyledNoWrap>
            {data?.createdByFirstName ?? ""} {data?.createdByLastName ?? ""}
          </StyledNoWrap>
        );

      default:
        return <div></div>;
    }
  };

  const getHeaderCell: (
    column: Column<CompanyContactPersonChargeDto>,
  ) => JSX.Element = column => {
    return <div>{column.label}</div>;
  };

  return (
    <>
      <StyledWrapper>
        <PrimaryDataTable
          rows={charges.map(x => ({
            data: x,
            rowEntityID: "companyContactPersonChargeID",
          }))}
          isLoading={false}
          columns={columns}
          getCell={getCell}
          getHeaderCell={getHeaderCell}
          hideTablePagination
        ></PrimaryDataTable>
      </StyledWrapper>
    </>
  );
};
